const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: '創新驅動',
      description: '持續探索遊戲產業的創新可能，運用最新技術與創意思維，為玩家帶來突破性的遊戲體驗。'
    },
    {
      icon: 'ri-user-heart-line',
      title: '玩家至上',
      description: '以玩家需求為核心，深入了解玩家喜好，提供優質的遊戲內容與服務，創造最佳的遊戲體驗。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '專業可靠',
      description: '擁有豐富的產業經驗與專業團隊，提供可靠的遊戲代理與營運服務，確保合作夥伴的成功。'
    },
    {
      icon: 'ri-team-line',
      title: '合作共贏',
      description: '與遊戲開發商、玩家社群建立長期合作關係，共同打造健康的遊戲生態系統，實現多方共贏。'
    }
  ];

  return (
    <section id="values" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題 */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            我們的<span className="text-orange-500">核心價值</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            堅持<strong>創新</strong>、<strong>專業</strong>與<strong>玩家至上</strong>的理念，打造卓越的遊戲產業服務
          </p>
        </div>

        {/* 價值卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 text-center group"
            >
              {/* 圖標 */}
              <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${value.icon} text-4xl text-white`}></i>
              </div>

              {/* 標題 */}
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {value.title}
              </h3>

              {/* 描述 */}
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
